import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useMatch } from "react-router-dom";
import {
  authIsAuthenticated,
  authUser,
} from "../redux/selectors/authSelectors";
import { UserSettings } from "../constants/AppConstants";
import { signOut } from "../redux/actions/authActions";
import { performMainAppSignOut } from "../common/sessionClear";
import {
  initMentors,
  initGetFeedBack,
  initGetSessions,
  initGetRecommendation,
  initGetStudentResources,
  initGetGreatFinds,
  removeChatHistoryLoaded,
} from "../redux/actions";

const useProfile = () => {
  const storageUser = useSelector((state) => authUser(state));
  const { role } = storageUser || {};
  const user = useSelector((state) => state?.profileReducer?.profile);
  const { studentResources, greatFinds, isLoadingGreat, isLoadingPicks } = useSelector((state) => state.studentResourcesReducer);
  const hasDispatched = useRef(false);
  const hasDispatchedPicks = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.school?.id && !hasDispatchedPicks.current) {
      handlePagePicks(1)
      hasDispatchedPicks.current = true;
    }
  }, [user]);
  useEffect(() => {
    if (!hasDispatched.current) {
      handlePageGreat(1);
      dispatch(initMentors());
      dispatch(initGetFeedBack());
      dispatch(initGetSessions());
      dispatch(initGetRecommendation());
      hasDispatched.current = true;
    }
  }, []);
  const handlePagePicks = (page) => {
    dispatch(initGetStudentResources({ schools: user?.school?.id, page: page }));
  }
  const handlePageGreat = (page) => {
    dispatch(initGetGreatFinds({ page: page }));
  }
  const { pathname } = useLocation();
  const [settings, setSettings] = useState(
    role === "Mentor" ? UserSettings.mentor : UserSettings.student
  );
  const [isInviteFriendModalopened, setInviteFriendModalopened] =
    useState(false);
  const [isLogOutModalOpened, setLogOutModalOpened] = useState(false);
  const profileMatch = useMatch("/profile/*");
  const isProfileChildRoute =
    profileMatch !== null && profileMatch.params["*"] !== "";

  const handleSettingClick = (id, arr) => {
    dispatch(removeChatHistoryLoaded({ isChatHistoryLoaded: false }))
    const changedSettings = arr.map((el) => ({
      ...el,
      isActive: el.id === id,
    }));
    setSettings(changedSettings);
  };

  const closeInviteFriendModal = () => {
    setInviteFriendModalopened(false);
  };

  const openInviteFriendModal = () => {
    setInviteFriendModalopened(true);
  };

  const openLogOutModal = () => {
    setLogOutModalOpened(true);
  };
  const closeLogoutModal = () => {
    setLogOutModalOpened(false);
  };
  const handleLogOut = () => {
    dispatch(signOut());
    performMainAppSignOut({ chainEducatorClear: true });
  };

  const isAuth = useSelector((state) => authIsAuthenticated(state));
  useEffect(() => {
    if (!isAuth) {
      // navigate("/signin");
    }
  }, [isAuth]);

  useEffect(() => {
    const changedSettings = settings.map((el) => ({
      ...el,
      isActive:
        (el.route === "recommendations" &&
          (pathname.split("/").pop() === "profile" ||
            pathname.split("/").pop() === "recommendations")) ||
        el.route === pathname.split("/").pop(),
    }));
    const activeEl = changedSettings.find((el) => el.isActive === true);
    if (activeEl === undefined) {
      if (
        pathname.split("/").pop() === "EditProfile" ||
        pathname.split("/").pop() === "editPassword"
      ) {
        const changedSettings = settings.map((el) => ({
          ...el,
          isActive: el.department === "Profile Info",
        }));
        setSettings(changedSettings);
      } else if (pathname.includes("career")) {
        const changedSettings = settings.map((el) => ({
          ...el,
          isActive: el.department === "Recommendations",
        }));
        setSettings(changedSettings);
      } else if (pathname.includes("ai-companions")) {
        const changedSettings = settings.map((el) => ({
          ...el,
          isActive: el.department === "AI Companions",
        }));
        setSettings(changedSettings);
      } else {
        setSettings(settings);
      }
    } else {
      setSettings(changedSettings);
    }
    setInviteFriendModalopened(false);
    setLogOutModalOpened(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return {
    user,
    pathname,
    settings,
    isInviteFriendModalopened,
    isLogOutModalOpened,
    isProfileChildRoute,
    studentResourcesList: studentResources,
    greatFinds: greatFinds,
    isLoadingGreat,
    isLoadingPicks,
    handleSettingClick,
    handleLogOut,
    closeInviteFriendModal,
    openInviteFriendModal,
    openLogOutModal,
    closeLogoutModal,
    handlePagePicks,
    handlePageGreat,
  };
};

export default useProfile;
